<template>
  <v-main>
    <AppBar hide-back title="비밀번호변경 안내" />
    <v-layout fill-height column>
      <v-container flex-fill fluid>
        <div class="text-center fw-500 letter-spacing-3 mt-1">
          <v-img contain height="138px" style="margin-bottom: 23px"
                 :src="getImage(guideCharacterPath)" />

          <h6 class="fs-20 fw-500 mb-6">
            개인정보를 위해<br/>비밀번호를 변경해 주세요.
          </h6>
          <p class="mb-3">회원님은 6개월 이상<br />비밀번호를 변경하지 않으셨습니다.</p>
          <p class="mb-6">개인 정보보호를 위해<br />비밀번호를 주기적으로 변경해 주세요.</p>
        </div>
        <div class="footer-btns vertical">
          <v-btn color="primary" class="btn-basic"
                 x-large depressed
                 @click="onSubmit(true)">
            변경하기
          </v-btn>
          <v-btn color="primary" class="btn-cancel"
                 x-large depressed
                 @click="onSubmit(false)">
            6개월 뒤에 변경하기
          </v-btn>
        </div>
      </v-container>
      <v-footer app color="transparent" class="content-footer">
      </v-footer>
    </v-layout>
  </v-main>
</template>

<script>
import { mixinRemote } from '@/mixins'
import store from "@/store";

export default {
  components: {},
  mixins: [ mixinRemote ],
  computed : {
    guideCharacterPath () {
      const selectRandomGuideCharacter = (arr) => (arr[Math.floor(Math.random() * arr.length)].checkPw)
      const {chaImgNo} = store.state.client.contract
      if (!chaImgNo) return selectRandomGuideCharacter(this.guides)

      return this.guides[chaImgNo].checkPw
    }
  },
  created () {
     if (!store.state.auth.authUser.changePasswordRequired) this.$router.back()
  },
  methods: {
   changeMaximumPasswordAge() {
     store.dispatch('setMemberMaximumPasswordAgeInner').then(res => {
        if (res.success) window.location.href = "/user"
        else this.$alert(res.msg)
      })
    },
    onSubmit (bool) {
      if (bool) this.$router.push({path: '/fo/join/changePassword', query:{required:1}});
      else this.changeMaximumPasswordAge();
    }
  }
}
</script>
